'use client';

import type { CSSProperties, ReactNode } from 'react';
import { forwardRef } from 'react';
import { cx } from '../../utils/cx';
import type { TypographyProps } from './utils/typographyHelper';
import { typographyInline } from './utils/typographyHelper';
import styles from './Mark.module.css';

export interface MarkProps extends TypographyProps {
  children?: ReactNode;
  className?: string;
  variant?: 'highlight' | 'transparent';
}

export const Mark = forwardRef<HTMLElement, MarkProps>((props, ref) => {
  const { children, className, variant = 'highlight' } = props;
  const style: CSSProperties = typographyInline(props);
  return (
    <mark
      ref={ref as React.Ref<HTMLElement>}
      className={cx(styles.mark, className)}
      data-variant={variant}
      style={style}
    >
      {children}
    </mark>
  );
});

Mark.displayName = 'Mark';
